import { IServiceStatusResponse } from "@wingspanhq/payments/dist/interfaces";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";

export const selectorDefaultCurrency = (
  paymentSettings?: IServiceStatusResponse
) => paymentSettings?.defaultAccountCurrency || Currency.USD;
